import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

const Root = styled.div`
  padding-top: var(--double-unit);
`;

const Block = styled(Horizontal)`
  width: 100%;
  padding: var(--double-unit);
  background: var(--c-surface-caution);
  color: var(--c-yellow-500);
  border-radius: var(--unit);
  justify-content: space-between;
`;

const DROP_WARNING_THRESHOLD = 8;

export const DropWarning = () => {
  const { currentUser } = useCurrentUserContext();

  if ((currentUser?.cardCounts?.common ?? 0) > DROP_WARNING_THRESHOLD)
    return null;
  return (
    <Root>
      <Block gap={2}>
        <FontAwesomeIcon icon={faInfoCircle} />
        <FormattedMessage
          id="DropWarning.warning"
          defaultMessage="Unable to swap card. You must own at least x{count} Common Cards in your gallery"
          values={{ count: DROP_WARNING_THRESHOLD }}
        />
      </Block>
    </Root>
  );
};
